import axios from 'axios';
import importMeta from 'utils/vite/importMeta';

const client = axios.create({
  baseURL: importMeta().env.VITE_KARD_BASE_API,
});

export default client;
